import { render } from "./TechAdvantage.vue?vue&type=template&id=7cc8621e&scoped=true"
import script from "./TechAdvantage.vue?vue&type=script&lang=js"
export * from "./TechAdvantage.vue?vue&type=script&lang=js"

import "./TechAdvantage.vue?vue&type=style&index=0&id=7cc8621e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc8621e"]])

export default __exports__